import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { displayMultiSelect } from "../Utility/ChipDisplay";
import QaFiltersDialog from "./QaFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IQaFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function QaFilters({ callTableViewModel, setCallTableViewModel }: IQaFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'QA Filters '
            }
            {
                callTableViewModel.filters.qaFilters.monitoringStatus ? ` - ${callTableViewModel.filters.qaFilters.monitoringStatus}` : ''
            }
            {
                displayMultiSelect(callTableViewModel.filters.qaFilters.monitoredBy, 'Monitored By')
            }
            {
                callTableViewModel.filters.qaFilters.monitoringResult ? ` - ${callTableViewModel.filters.qaFilters.monitoringResult}` : ''

            }
            {
                callTableViewModel.filters.qaFilters.monitoringResqResult ? ` - ${callTableViewModel.filters.qaFilters.monitoringResqResult}` : ''

            }
            {
                callTableViewModel.filters.qaFilters.alert
                    ? ` - ${callTableViewModel.filters.qaFilters.alert}`
                    : ''

            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <QaFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}